/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-explicit-any -- pre-existing legacy code, not touched in this pass; typing this properly is tracked separately */
import { CSSProperties } from "react";
import { BoxRollType, CargoAttributes, ContainerType, GeneralType, TruckType } from "store";
import { isLocalhost } from "utils/helper";
import { containers } from "./containers";
import { colors, pallet_types } from "./data";
import { trucks } from "./trucks";

export const randomColor = (): CSSProperties["color"] => {
  const randomColorIndex = Math.floor(Math.random() * 48);
  return colors[randomColorIndex];
};
// eslint-disable-next-line no-console -- dev-only debug utility
export const logMutations = <T extends any = any>(obj: T) => console.log(JSON.parse(JSON.stringify(obj)));
export const clone = <T extends any = any>(obj: T) => JSON.parse(JSON.stringify(obj));

export const convertSize = (type: string, options: any) => {
  const convertedUnits: any = {};
  Object.keys(pallet_types[type].size).forEach((key: string) => {
    convertedUnits[key] = convertUnits(pallet_types[type].size[key], options.lengthUnits);
  });
  return convertedUnits;
};

export const filterToContainerTypes = (stuffingData: any) => {
  let obj: any = {};

  stuffingData?.forEach((item: any) => {
    obj = {
      ...obj,
      [item.attr.type]: [...(obj[item.attr.type] ? obj[item.attr.type] : []), item],
    };
  });

  return obj;
};

export const getIndex = (arr: any, itemInstance: any) => {
  let index = 0;
  arr.map((item: any, i: number) => {
    if (item.uid === itemInstance.uid) {
      index = i;
    }
  });
  return index;
};

export const capitalize = (itemKey: string) => {
  return itemKey
    .replace(/([A-Z])/g, " $1")
    .split(" ")
    .map((item) => item[0].toUpperCase() + item.slice(1))
    .join(" ");
};

export const getPredictionQuantity = (sizes: any, containerTypes: any, productType: string) => {
  const calculatedContainerVolume: any = [];

  containerTypes.forEach((containerType: string) => {
    const container = generateTransport(containerType, "mm", "kg").spaces[0];
    const containerVolume = container.length * container.width * container.height;
    const boxVolume = sizes.length * sizes.width * sizes.height;
    const rollVolume = Math.PI * sizes.radius * sizes.radius * sizes.height;
    const resultingVolume = productType === "roll" ? rollVolume : boxVolume;
    const maxBoxQuantityPerVolume = Math.floor(containerVolume / resultingVolume);
    const maxBoxQuantityPerWeight = Math.floor(container.maxWeight / sizes.mass);

    calculatedContainerVolume.push({
      // @ts-ignore
      type: typeToString(containerType),
      capacity: Math.min(maxBoxQuantityPerVolume, maxBoxQuantityPerWeight),
    });
  });
  return calculatedContainerVolume;
};

export const getInitValProducts = (groups: any) => {
  const productsFields: any = {};
  groups.forEach((group: any) => {
    group.items.forEach((item: any) => {
      productsFields[`name-${item.uid}`] = item.name;
      productsFields[`length-${item.uid}`] = item.size.length;
      productsFields[`diameter-${item.uid}`] = item.size.diameter;
      productsFields[`width-${item.uid}`] = item.size.width;
      productsFields[`height-${item.uid}`] = item.size.height;
      productsFields[`weight-${item.uid}`] = item.weight;
      productsFields[`quantity-${item.uid}`] = item.qty;
      productsFields[`radius-${item.uid}`] = item.size.radius;
    });
    if (group.pallets) {
      productsFields[`length-${group.pallets.uid}`] = group.pallets.size.length;
      productsFields[`width-${group.pallets.uid}`] = group.pallets.size.width;
      productsFields[`height-${group.pallets.uid}`] = group.pallets.size.height;
      productsFields[`depth-${group.pallets.uid}`] = group.pallets.depth;
      productsFields[`max_weight-${group.pallets.uid}`] = group.pallets.maxWeight;
    }
  });
  return productsFields;
};

export const changeProductValue = (e: any, groups: any) => {
  if (e.target.name) {
    // name example - length-1122
    const nameWithId = e.target.name;
    const index = nameWithId.indexOf("-") + 1;
    // get id - 1122
    const id = nameWithId.slice(index, nameWithId.length);
    // get name - length
    const name = nameWithId.slice(0, index - 1);

    const newGroups = [...groups];

    groups.forEach((group: any) => {
      const currentGroup = newGroups.find((currentGroup) => currentGroup.uid === group.uid);
      const currentGroupIndex = newGroups.indexOf(currentGroup);

      const table = e.target.closest("[data-table]");
      const typeChanged = table ? table.dataset.table : null;

      if (group.pallets && typeChanged === "pallet") {
        switch (name) {
          case "length":
          case "width":
          case "height":
            newGroups[currentGroupIndex].pallets.size[name] = +e.target.value;
            break;
          default:
            newGroups[currentGroupIndex].pallets[name] = +e.target.value;
        }
        return;
      }

      group.items.forEach((item: any) => {
        if (item.uid === id) {
          // get group index of current item and item index
          const currentItem = newGroups[currentGroupIndex].items.find(
            (currentItem: any) => currentItem.uid === item.uid
          );
          const currentItemIndex = newGroups[currentGroupIndex].items.indexOf(currentItem);

          // then change the value of current item in groups array
          switch (name) {
            case "length":
            case "width":
            case "height":
            case "diameter":
            case "radius":
              newGroups[currentGroupIndex].items[currentItemIndex].size[name] = +e.target.value;
              break;
            case "quantity":
              newGroups[currentGroupIndex].items[currentItemIndex].qty = e.target.value;
              break;
            case "name":
              newGroups[currentGroupIndex].items[currentItemIndex].name = e.target.value;
              newGroups[currentGroupIndex].items[currentItemIndex].name = e.target.value;
              break;
            default:
              newGroups[currentGroupIndex].items[currentItemIndex][name] = e.target.value;
          }
        }
      });
    });
  } else {
    return;
  }
};

export const getInitValContainers = (containers: any) => {
  const transportFields: any = {};
  containers.forEach((container: any) => {
    transportFields[`length-${container.uid}`] = container.spaces[0].length;
    transportFields[`width-${container.uid}`] = container.spaces[0].width;
    transportFields[`height-${container.uid}`] = container.spaces[0].height;
    transportFields[`maxMass-${container.uid}`] = container.spaces[0].maxWeight;

    if (container.axisLoad) {
      transportFields[`front_mass-${container.uid}`] = container.axisLoad.front.mass;
      transportFields[`rear_mass-${container.uid}`] = container.axisLoad.rear.mass;
      transportFields[`front_offset-${container.uid}`] = container.axisLoad.front.offset;
      transportFields[`rear_offset-${container.uid}`] = container.axisLoad.rear.offset;
    }
  });
  return transportFields;
};

export const changeTransportValue = (e: any, containers: any) => {
  if (e.target.name) {
    // name example - length-1122
    const nameWithId = e.target.name;
    const index = nameWithId.indexOf("-") + 1;
    // get id - 1122
    const id = nameWithId.slice(index, nameWithId.length);
    // get name - length
    const name = nameWithId.slice(0, index - 1);

    const newContainers = [...containers];

    containers.forEach((container: any) => {
      if (container.uid === id) {
        const currentContainer = containers.find((current: any) => current.uid === container.uid);
        const currentContainerIndex = containers.indexOf(currentContainer);

        switch (name.trim()) {
          case "front_mass":
          case "rear_mass":
          case "front_offset":
          case "rear_offset":
            const [firstName, secondName] = name.split("_");
            newContainers[currentContainerIndex]["axisLoad"][firstName][secondName] = Number(e.target.value);
            break;
          case "maxMass":
            newContainers[currentContainerIndex]["spaces"][0]["maxWeight"] = Number(e.target.value);
            break;
          default:
            newContainers[currentContainerIndex]["spaces"][0][name] = Number(e.target.value);
        }
      }
    });

    return newContainers;
  } else {
    return;
  }
};

export type ProductsValueType = {
  uid: string;
  name: string;
  qty: number;
  weight: number;
  volume: number;
  type: BoxRollType;
  color: CSSProperties["color"];
};
export const getProductsValues = (
  items: GeneralType["items"],
  cargoesAttributes: CargoAttributes
): ProductsValueType[] => {
  return Object.keys(items).map((key: string) => ({
    uid: key,
    name: cargoesAttributes[key]?.name ?? "",
    color: cargoesAttributes[key]?.color,
    // @ts-ignore
    qty: items[key], // @ts-ignore
    weight: cargoesAttributes[key]?.weight * items[key], // @ts-ignore
    volume: cargoesAttributes[key]?.volume * items[key],
    type: cargoesAttributes[key]?.type,
  }));
};

export const convertUnits = (value: number, convertTo: string): number => {
  let result;

  const measurements = {
    mm: { name: "mm", coof: 1 },
    cm: { name: "cm", coof: 10 },
    m: { name: "m", coof: 1000 },
    inch: { name: "inch", coof: 39.37 },
    ft: { name: "ft", coof: 3.28 },
    fts: { name: "fts", coof: 3.28 },
    kg: { name: "kg", coof: 1 },
    lb: { name: "lb", coof: 2.2046 },
  };

  switch (convertTo) {
    case "mm":
      result = value * measurements.mm.coof;
      break;
    case "cm":
      result = value / measurements.cm.coof;
      break;
    case "m":
      result = value / measurements.m.coof;
      break;
    case "inch":
      result = (value * measurements.inch.coof) / 1000;
      break;
    case "ft":
    case "fts":
      result = (value * measurements.fts.coof) / 1000;
      break;
    case "kg":
      result = value * measurements.kg.coof;
      break;
    case "lb":
      result = value * measurements.lb.coof;
      break;
    default:
      result = value;
  }
  return Number(result);
};

export const convertToMM = (value: number, convertFrom: string) => {
  if (value) {
    let mm;

    switch (convertFrom) {
      case "mm":
        mm = value;
        break;
      case "kg":
        mm = value;
        break;
      case "cm":
        mm = value * 10;
        break;
      case "m":
        mm = value * 1000;
        break;
      case "inch":
        mm = value * 25.4;
        break;
      case "ft":
      case "fts":
        mm = value * 304.8;
        break;
      case "lb":
        mm = value * 2.204;
        break;
      default:
        mm = value;
    }
    return Number(mm);
  } else {
    return null;
  }
};

export const resizeInputWidth = (e: any) => {
  e.target.size = e.target.value.length + 1;
};

export const generateId = () =>
  Math.floor((1 + Math.random()) * 0x100000)
    .toString(16)
    .substring(0);

export const getGeometryType = (type: string) => {
  switch (type) {
    case "box":
    case "bigbags":
    case "bulk":
    case "sacks":
      return "box";
    case "barrels":
    case "pipes":
    case "roll":
      return "roll";
    default:
      return "box";
  }
};

export const typeToString = (type: ContainerType | TruckType) => {
  switch (type) {
    case "20st":
      return "20 Standard";
    case "40st":
      return "40 Standard";
    case "40hq":
      return "40 High Cube";
    case "20ref":
      return "20 Refrigerated";
    case "40ref":
      return "40 Refrigerated";
    case "20op":
      return "20 Open Top";
    case "40op":
      return "40 Open Top";
    case "20ft":
      return "20 Flatrack";
    case "40ft":
      return "40 Flatrack";
    case "20fc":
      return "20 Flatrack Collapsible";
    case "40fc":
      return "40 Flatrack Collapsible";
    case "20p":
      return "20 Platform";
    case "40p":
      return "40 Platform";
    case "20bulk":
      return "20 Bulk";
    case "20tank":
      return "20 Tank";

    case "tautliner":
      return "Tautliner (Curainsider)";
    case "refrigerated":
      return "Refrigerated Truck";
    case "isotherm":
      return "Isotherm Truck";
    case "mega_trailer":
      return "Mega-trailer";
    case "jumbo":
      return "Jumbo";
    case "custom_truck":
      return "Custom Truck";

    default:
      return "Custom Container";
  }
};

export const generateTransport = (type: string, length: any, weight: any) => {
  const transportType = getTransportType(type);

  const newTransport: any = {
    groups: [],
    spaces: [
      {
        height: 0,
        width: 0,
        length: 0,
        maxWeight: 0,
      },
    ],
    loadType: "auto",
    attr: {
      type: type,
    },
    type: transportType,
    uid: generateId(),
    qty: 1,
  };

  const getSpaces = (transport: any) => {
    transport.forEach((item: any) => {
      if (item.type === type) {
        newTransport.spaces[0].height = convertUnits(Number(item.insideHeight.match(/\d/g).join("")), length);
        newTransport.spaces[0].width = convertUnits(Number(item.insideWidth.match(/\d/g).join("")), length);
        newTransport.spaces[0].length = convertUnits(Number(item.insideLength.match(/\d/g).join("")), length);
        newTransport.spaces[0].maxWeight = convertUnits(Number(item.maxWeight.match(/\d/g).join("")), weight);
      }
    });
  };

  if (transportType === "container") {
    getSpaces(containers);

    switch (type) {
      case "Demi":
      case "ULD-1":
      case "ULD-29":
        newTransport.spaces[0].unused = [
          {
            size: {
              x: 100,
              y: 100,
              z: 100,
            },
            position: {
              x: 100,
              y: 100,
              z: 100,
            },
          },
        ];
    }
  }

  if (transportType === "truck") {
    getSpaces(trucks);
    newTransport.axisLoad = {
      front: {
        offset: 100,
        mass: 200,
      },
      rear: {
        offset: 100,
        mass: 300,
      },
    };
  }

  return newTransport;
};

export const getTransportType = (type: string) => {
  const isShipContainer = containers.some((object) => {
    return object.type === type;
  });

  return isShipContainer ? "container" : "truck";
};

(() => {
  if (!isLocalhost) return;
  window.addEventListener("keydown", (e: any) => {
    if (e.keyCode === 123) {
      debugger;
    }
  });
})();
